<template lang="pug">
.other-user-group-member-detail-modal
  b-modal(v-model="_value" size="xl" no-close-on-backdrop no-close-on-esc hide-footer)
    .other-user-group-member-detail-modal-table
      .thead
        .header-line
          .th.sender-type 送信手段
          .th.name ユーザー名
          .th.tel 電話番号
          .th.organization 所属
          .th.room-schedule-function 空室／空床情報
          .th.operation 登録情報
          .th.send-message 登録確認
      .tbody
        .body-line(v-for="member in members")
          // 送信手段
          .td.sender-type.center {{ convertSenderType(member.senderType) }}
          // ユーザー名
          .td.name {{ member.memberName }}
          // 電話番号
          .td.tel {{ member.memberTel }}
          // 所属
          .td.organization(v-if="member.memberOrganization") {{ member.memberOrganization }}
          .td.organization(v-else) 未設定
          // 空室情報
          template(v-if="member.senderType == 1")
            .td.room-schedule-function －
          template(v-else)
            .td.room-schedule-function.used(v-if="member.otherUserPermittedFunctions.vacancy") 使用可
            .td.room-schedule-function.unused(v-else) 使用不可
          // 登録情報
          .td.operation.center
            button.btn.edit-btn.mr-1(@click="onEdit(member)") 修正
            button.btn.delete-btn.mr-1(@click="onDelete(member)") 削除
            button.btn.transfer-btn(@click="onTransferMember(member, $event)") 他施設へ移動／コピー
          // 登録確認
          .td.send-message.center
            button.btn.testmail-btn(v-if="member.senderType == 1" @click="onSendMessage(member)") 確認送信
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import OtherUserGroup from "@/commons/models/OtherUserGroup";
import { SenderType } from "@/commons/models/Resident";

/**
 * ### 施設関係者グループユーザー詳細表示モーダル
 */
@Component
export default class OtherUserGroupMemberDetailModal extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;

  /**
   * 施設関係者グループユーザー
   */
  @Prop({
    default: () => {
      return [];
    }
  })
  members!: Array<OtherUserGroup>;

  @Prop()
  modelShow!: boolean;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  /**
   * ### 送信手段文字列を返す
   */
  public convertSenderType(senderType: SenderType): string {
    if (senderType == SenderType.LINE) {
      return "LINE";
    } else if (senderType == SenderType.MAIL) {
      return "メール";
    } else {
      return "";
    }
  }

  /**
   * ### 修正ボタン押下イベント
   */
  public onEdit(member: OtherUserGroup): void {
    this.$emit("onEdit", member);
    return;
  }

  /**
   * ### 削除ボタン押下イベント
   */
  public onDelete(member: OtherUserGroup): void {
    this.$emit("onDelete", member);
    return;
  }

  /**
   * ### 施設関係者メンバーの移動／コピーボタン押下イベント
   */
  public onTransferMember(member: OtherUserGroup, bvModalEvent: any): void {
    bvModalEvent.preventDefault();
    this.$emit("onTransferMember", member);
    return;
  }

  /**
   * ### 確認送信ボタン押下イベント
   */
  public onSendMessage(member: OtherUserGroup): void {
    this.$emit("onSendMessage", member);
    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";
.used {
  color: $font-key-color;
  font-weight: bold;
}
.unused {
  color: $font-disable-font-color;
}
</style>
